import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue, RequestModeControlName } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  MIRNewRequestControlName,
  MIRNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class MIRNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<MIRNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
          [RequestModeControlName.RequestMode]: true,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [MIRNewRequestControlName.ObjectDescription]: this.formBuilder.control(
        getDefaultControlValue(),
        Validators.required,
      ),
      [MIRNewRequestControlName.FoodCourtStartDate]: this.formBuilder.control(
        getDefaultControlValue(),
        Validators.required,
      ),
      [MIRNewRequestControlName.MonumentInstallationDateRange]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [MIRNewRequestControlName.Justification]: this.formBuilder.control(
        getDefaultControlValue(),
        Validators.required,
      ),
      [MIRNewRequestControlName.DeterminationOfLocation]:
        this.formBuilder.control(getDefaultControlValue()),
      [MIRNewRequestControlName.WorkScope]: this.formBuilder.control(
        getDefaultControlValue(),
        Validators.required,
      ),
      [MIRNewRequestControlName.Project]: this.formBuilder.control(
        getDefaultControlValue(),
        Validators.required,
      ),
    });
  }
}
